import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ChipSelector, { ChipOption } from "../../../common/form/ChipSelect/ChipSelector";

interface Props {
  value: string[];
  onChange: (v: string[]) => void;
}

export default function CareerInterestsEditor({ value, onChange }: Props) {
  const { t } = useTranslation();
  const careerOptions: ChipOption[] = useMemo(
    () => [
      { key: "business", value: t("text.companion_onboarding_career_business") },
      { key: "hospitality", value: t("text.companion_onboarding_career_hospitality") },
      { key: "global_trade", value: t("text.companion_onboarding_career_global_trade") },
      { key: "creative_arts", value: t("text.companion_onboarding_career_creative_arts") },
      { key: "entertainment", value: t("text.companion_onboarding_career_entertainment") },
      { key: "design", value: t("text.companion_onboarding_career_design") },
      { key: "education", value: t("text.companion_onboarding_career_education") },
      { key: "engineering", value: t("text.companion_onboarding_career_engineering") },
      { key: "technology", value: t("text.companion_onboarding_career_technology") },
      { key: "mathematics", value: t("text.companion_onboarding_career_mathematics") },
      { key: "sciences", value: t("text.companion_onboarding_career_sciences") },
      { key: "health_sciences", value: t("text.companion_onboarding_career_health_sciences") },
      { key: "law", value: t("text.companion_onboarding_career_law") },
      { key: "public_services", value: t("text.companion_onboarding_career_public_services") },
      { key: "manufacturing", value: t("text.companion_onboarding_career_manufacturing") },
      { key: "industrial_technology", value: t("text.companion_onboarding_career_industrial_technology") },
    ],
    [t]
  );

  return <ChipSelector options={careerOptions} selectedKeys={value ?? []} onSelectionChange={onChange} multiSelect />;
}
